import type { ReportConfiguration } from '../report-configurations/reportConfigurationsTypes';

import type * as types from './generatedReportsTypes';

export function transformResponseToReport(response: any, reportConfiguration: ReportConfiguration): types.Report {
  const data = response.data.resources ? response.data.resources[0] : response.data;

  const rows: types.ReportRow[] = data.rows.map((row: any) => transformResponseRowToReportRow(row, ''));
  let columns: types.ReportColumn[] = data.columns.map((column: any) => transformResponseColumnToReportColumn(column));

  // TODO: This should be removed when QCS fixes issue with outputting a total column or cellData for total
  //       column when there is only a single column of report data.
  //
  if (columns.length === 2 && columns[1].isAggSum) {
    columns = columns.slice(0, -1);
    rows.forEach((row) => {
      if (row.cellData.length === 2) {
        row.cellData = row.cellData.slice(0, -1);
      }
    });
  }

  return {
    configuration: reportConfiguration,
    name: reportConfiguration.name || 'unknown',

    reportType: data.reportType,
    reportSubType: data.reportSubType,

    startOn: data.startOn,
    endOn: data.endOn,

    total: data.total,

    rowType: data.rowType,
    rows,

    columnType: data.columnType,
    columns,
  };
}

function transformResponseColumnToReportColumn(column: any): types.ReportColumn {
  let headerValue: any;
  switch (column.headerType) {
    case 'DATE_RANGE':
      headerValue = { startOn: column.headerValue.startOn, endOn: column.headerValue.endOn };
      break;
    case 'QCS_ENTITY':
      headerValue = { id: column.headerValue.id, qcs_entity: column.headerValue.qcs_entity };
      break;
    case 'STRING':
    default:
      headerValue = { id: column.headerValue.id, string: column.headerValue.string };
  }

  return {
    id: column.id,

    headerType: column.headerType,
    headerValue,

    cellType: column.cellType,
    isAggSum: column.isAggSum,
  };
}

function transformResponseRowToReportRow(row: any, idPrefix: string): types.ReportRow {
  return {
    id: `${idPrefix}${row.id}`,
    parentId: row.parentId !== undefined ? `${idPrefix}${row.parentId}` : undefined,
    name: `${idPrefix}${row.name}`,
    entityId: row.entityId,
    childrenEntityIds: row.childrenEntityIds,
    expectedSign: row.expectedSign,
    cellData: row.cellData.map((cell: any) => ({
      id: cell.id,
      columnId: cell.columnId,
      value: cell.value,
    })),
    other: row.other,
  };
}
